import { render, staticRenderFns } from "./UsersPaidTariffs.vue?vue&type=template&id=85208fc2&"
import script from "./UsersPaidTariffs.vue?vue&type=script&lang=js&"
export * from "./UsersPaidTariffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports